/**
 * Created by rathompson on 11/10/21
 * File: ZIndex
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */
import { useEffect, VFC } from 'react'
import { v4 } from 'uuid'
import { DATA_TEST_Z_INDEX } from '../../constants/TestingDataIds'

/***
 * @param children
 * @param passthrough
 * @returns {JSX.Element}
 * @constructor
 * @desc Standardizes the z-index values across our application
 */
const ZIndex: VFC<any> = ({ children, ...passthrough }) => {

  const id = `z-index-${v4()}`

  useEffect(() => {
    const config = { attributes: true, childList: true, subtree: true }
    const observer = new MutationObserver(() => {
      const z10Elements = Array.from(document.getElementsByClassName('tw-z-10')) as HTMLElement[]
      if (z10Elements && z10Elements.length) {
        for (const z10Element of z10Elements) {
          z10Element.style.zIndex = '1051'
        }
      }
      const z20Elements = Array.from(document.getElementsByClassName('tw-z-20')) as HTMLElement[]
      if (z20Elements && z20Elements.length) {
        for (const z20Element of z20Elements) {
          z20Element.style.zIndex = '1052'
        }
      }
      const z30Elements = Array.from(document.getElementsByClassName('tw-z-30')) as HTMLElement[]
      if (z30Elements && z30Elements.length) {
        for (const z30Element of z30Elements) {
          z30Element.style.zIndex = '1053'
        }
      }
      const z40Elements = Array.from(document.getElementsByClassName('tw-z-40')) as HTMLElement[]
      if (z40Elements && z40Elements.length) {
        for (const z40Element of z40Elements) {
          z40Element.style.zIndex = '1054'
        }
      }
      const z50Elements = Array.from(document.getElementsByClassName('tw-z-50')) as HTMLElement[]
      if (z50Elements && z50Elements.length) {
        for (const z50Element of z50Elements) {
          z50Element.style.zIndex = '1055'
        }
      }
    })
    const node = document.getElementById(id)
    if (node) {
      observer.observe(document.getElementById(id) as Node, config)
    }
    return () => observer.disconnect()
  }, [id])

  return (<div {...passthrough} data-testid={DATA_TEST_Z_INDEX} id={id}>{children}</div>)
}

ZIndex.propTypes = {}
export default ZIndex
